var _style, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNginx(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 130 90",
    style: {
      enableBackground: "new 0 0 130 90"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#009900;}\r\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M33.7,55.5c-0.6,0-1.1-0.2-1.5-0.6L19.3,42v11.3c0,1.2-1,2.2-2.2,2.2c-1.2,0-2.2-0.9-2.2-2.2V36.7 c0-0.9,0.5-1.7,1.3-2c0.8-0.3,1.7-0.1,2.4,0.5L31.6,48V36.7c0-1.2,1-2.2,2.2-2.2c1.2,0,2.2,1,2.2,2.2v16.5 C35.9,54.4,34.9,55.4,33.7,55.5 M43.8,34.5l-0.6,1.1L38.6,44L38,45.1l0.6,1.1l4.6,8.1l0.6,1.1h12.1l0.6-1.2l3.5-7l1.5-3.2H58l-8.8,0 c-1.1,0-2.2,1-2.2,2.2s1.1,2.2,2.2,2.2l5.3,0L53.2,51h-6.8l-3.4-6l3.4-6.2h7.3l1.7,3.5h4.4L57,35.7l-0.6-1.2L43.8,34.5 M65.8,34.5 c-1.1,0-2.2,1.1-2.1,2.2v5.7H68v-5.7C68,35.5,67,34.5,65.8,34.5 M72.8,55.5c-1.2,0-2.2-1-2.2-2.2V36.8c0-1.2,1-2.2,2.2-2.2 s2.2,1,2.2,2.2v11.3l12.9-12.9c0.6-0.6,1.6-0.8,2.4-0.5s1.3,1.1,1.3,2v16.6c0,1.2-1,2.2-2.2,2.2c-1.2,0-2.2-1-2.2-2.2V42L74.3,54.9 C73.9,55.3,73.4,55.5,72.8,55.5 M107.6,45l6.8-6.7c0.8-0.8,0.8-2.2,0-3.1s-2.2-0.8-3.1,0l-6.8,6.7l-6.8-6.7c-0.8-0.8-2.2-0.8-3.1,0 c-0.8,0.9-0.8,2.2,0,3.1l6.8,6.7l-6.8,6.7c-0.8,0.8-0.8,2.2,0,3.1c0.4,0.4,1,0.6,1.5,0.6c0.5,0,1.1-0.2,1.5-0.6l6.7-6.7l6.7,6.7 c0.4,0.4,1,0.6,1.5,0.6c0.6,0,1.1-0.2,1.5-0.6c0.8-0.8,0.8-2.2,0-3.1L107.6,45 M65.7,55.4c-1.1,0-2.2-1.1-2.1-2.2v-9.1h4.3v9.1 C67.9,54.4,66.9,55.4,65.7,55.4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNginx);
export default __webpack_public_path__ + "static/media/Nginx.09578fd78ef121e5f352697cdc3532fa.svg";
export { ForwardRef as ReactComponent };